import styled, { css } from 'styled-components';

export const Item = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s1};
  `,
);

export const Caption = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
    display: -webkit-box;
    max-width: ${theme.sz.s24};
    overflow: hidden;
    color: ${theme.co.neutral99};
    font-size: ${theme.sz.s3};
    text-align: center;
    text-shadow:
      0 1px 2px hsla(0, 0%, 0%, 0.8),
      0 0 6px hsla(0, 0%, 0%, 0.45);
    overflow-wrap: break-word;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  `,
);

const railButtonStyles = css(
  ({ theme }) => css`
    width: ${theme.sz.s10};
    height: ${theme.sz.s10};
    border: 0;
    border-radius: ${theme.bo.round};
    background-color: hsla(0, 0%, 12%, 0.45);
    backdrop-filter: blur(6px);
    box-shadow: 0 1px 4px hsla(0, 0%, 0%, 0.25);
    color: ${theme.co.neutral99};
    font-size: ${theme.sz.s5};
    cursor: pointer;

    &:hover:not(:disabled) {
      background-color: hsla(0, 0%, 12%, 0.6);
    }

    &:disabled {
      cursor: default;
      opacity: 0.5;
    }

    ${theme.focusVisible};
  `,
);

export const RailButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  ${railButtonStyles};

  &&[aria-pressed='true'] {
    background-color: ${({ theme }) => theme.co.primary20};
    color: ${({ theme }) => theme.co.neutral10};
  }
`;

export const LocalButton = styled.button(
  ({ theme }) => css`
    display: flex;
    padding: 0;
    border: 0;
    border-radius: ${theme.bo.round};
    background: none;
    box-shadow: 0 1px 4px hsla(0, 0%, 0%, 0.35);
    cursor: pointer;

    ${theme.focusVisible};
  `,
);

export const LocalAvatarFrame = styled.div(
  ({ theme }) => css`
    display: flex;
    border-radius: ${theme.bo.round};
    box-shadow: 0 1px 4px hsla(0, 0%, 0%, 0.35);
  `,
);

export const LocalVideoFrame = styled.div(
  ({ theme }) => css`
    width: ${theme.sz.s10};
    height: ${theme.sz.s10};
    overflow: hidden;
    border: ${theme.bo.mediumWidth} solid ${theme.co.neutral99};
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.neutral30};

    video {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      pointer-events: none;
    }
  `,
);

export const Rail = styled.div<{ $inline: boolean; $light: boolean }>(
  ({ theme, $inline, $light }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s4};

    ${
      !$inline &&
      css`
        position: absolute;
        top: 50%;
        inset-inline-end: ${theme.sz.s4};
        z-index: ${theme.zi.z2};
        transform: translateY(-50%);
      `
    }

    ${
      $light &&
      css`
        ${Caption} {
          color: ${theme.co.neutral20};
          text-shadow: none;
        }

        ${RailButton} {
          background-color: transparent;
          backdrop-filter: none;
          color: ${theme.co.neutral10};

          &:hover:not(:disabled) {
            background-color: ${theme.co.primary95};
          }
        }
      `
    }
  `,
);
